import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import { useFetchAPI } from 'hooks'
import { Loading, Subtitle } from 'ui/acro'

import RecommendedCarousel from './RecommendedCarousel'

const Recommended = ({ planId }) => {
  const [{ data, loading, error }] = useFetchAPI(`/plans/${planId}/recommended`)

  return (
    <Loading loading={loading} error={error}>
      {data && (
        <Fragment>
          <Subtitle color='primary' textAlign='center' pb={'22px'}>
            Recommended for you
          </Subtitle>
          <RecommendedCarousel plans={data} />
        </Fragment>
      )}
    </Loading>
  )
}

Recommended.propTypes = {
  planId: PropTypes.number
}

export default Recommended
